import { TabbedFilters } from "../../../../experiments/BubbleJourney/layouts/TabbedFilters";
import FilterHeader from "../../components/FilterHeader";

export default function CombinedFilters() {
  return (
    <>
      <FilterHeader />
      <TabbedFilters />
    </>
  );
}
